import { cn } from "@/zapi-frontend/shared/lib/utils";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { TClaimEvidence } from "../model/types";

const colorMap = {
  red: "bg-red-50 text-[#A73528] border border-[#A73528]",
  yellow: "border-[#B8842E] bg-[#FCF5EB] text-[#B8842E]",
  green: "bg-green-50 text-innoveraGreen-700 border border-innoveraGreen-700"
};

const config: Record<TClaimEvidence["evidenceStrength"], { className: string; label: string }> = {
  none: { className: colorMap.red, label: "No Evidence" },
  contradicting_weak: { className: colorMap.red, label: "Contradicting" },
  contradicting_medium: { className: colorMap.red, label: "Contradicting" },
  contradicting_strong: { className: colorMap.red, label: "Contradicting" },
  weak: { className: colorMap.yellow, label: "Weak" },
  medium: { className: colorMap.yellow, label: "Medium" },
  strong: { className: colorMap.green, label: "Strong" }
};

export function EvidenceStatusBadge({ strength }: { strength: TClaimEvidence["evidenceStrength"] | null }) {
  const className = config[strength ?? "none"].className;
  const label = config[strength ?? "none"].label;

  return (
    <div className={cn("py-[4px] px-[10px] rounded-[16px] border cursor-default", className)}>
      <FigmaTypography variant="label-3">{label}</FigmaTypography>
    </div>
  );
}
